import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import { TripCardProps } from '../types';
import { useMainContainerProvider } from '../../../../mainContainerProvider';
import useFetchWithAuth from '../../../../CommonHooks/useFetchWithAuth';
import { errorToast } from '../../../../CommonComponent/toast';
import { happeningBaseUrl } from '../../../../baseUrl';
import { HappeningType } from '../../../../globalContant';
import { noop } from 'lodash';
import { asyncNoop } from '../../../../util';

interface TripContextType {
  tripList: TripCardProps[];
  setTripList: React.Dispatch<React.SetStateAction<TripCardProps[]>>;
  setSelectedTrip: React.Dispatch<React.SetStateAction<TripCardProps>>;
  selectedTrip: TripCardProps;
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  files: File[];
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  getAllTrips: () => Promise<void>;
  setOldFiles: React.Dispatch<React.SetStateAction<string[]>>;
  oldFiles: string[];
  setIsNew: React.Dispatch<React.SetStateAction<boolean>>;
  isNew: boolean;
}

const intialData: TripContextType = {
  tripList: [],
  setTripList: noop,
  setSelectedTrip: noop,
  selectedTrip: {
    title: '',
    eventDate: '',
    description: '',
    interactions: [],
  },
  setFiles: noop,
  files: [],
  isLoading: false,
  setIsLoading: noop,
  getAllTrips: asyncNoop,
  setOldFiles: noop,
  oldFiles: [],
  setIsNew: noop,
  isNew: false,
};

const TripContext = createContext<TripContextType>(intialData);
const TripProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [tripList, setTripList] = useState<TripCardProps[]>([]);
  const [isNew, setIsNew] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>([]);
  const [oldFiles, setOldFiles] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { instituteId } = useMainContainerProvider();
  const { fetchWithAuth } = useFetchWithAuth();
  const [selectedTrip, setSelectedTrip] = useState<TripCardProps>({
    title: '',
    eventDate: '',
    description: '',
    interactions: [],
  });

  const getAllTrips = async () => {
    setIsLoading(true);
    const { error, data } = await fetchWithAuth(`get-happening/?type=${HappeningType.SCHOOL_TRIP}&instituteId=${instituteId}`, {}, happeningBaseUrl);
    setIsLoading(false);
    if (error) {
      errorToast(error);
    } else {
      const updatedResult = data?.result.map((item: TripCardProps) => {
        return {
          ...item,
          interactions: typeof item.interactions === 'string' ? JSON.parse(item.interactions) : item.interactions,
        };
      });
      setTripList(updatedResult ? updatedResult : []);
    }
    // eslint-disable-next-line
  };

  useEffect(() => {
    if (!tripList.length) {
      getAllTrips();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <TripContext.Provider
      value={{
        tripList,
        setTripList,
        setSelectedTrip,
        selectedTrip,
        setFiles,
        files,
        isLoading,
        setIsLoading,
        getAllTrips,
        oldFiles,
        setOldFiles,
        setIsNew,
        isNew,
      }}
    >
      {children}
    </TripContext.Provider>
  );
};

export default TripProvider;

export const useTripProvider = () => useContext(TripContext);
